import React from 'react';

interface LinkedInIconProps {
  width?: number;
  height?: number;
  className?: string;
}

export default function LinkedInIcon({ width = 22, height = 22, className = '' }: LinkedInIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
    >
      <path
        d="M0.5 2.00429C0.5 1.17397 1.19513 0.5 2.05203 0.5H19.948C20.8052 0.5 21.5 1.17397 21.5 2.00429V19.996C21.5 20.8265 20.8052 21.5 19.948 21.5H2.05203C1.19521 21.5 0.5 20.8266 0.5 19.9962V2.00404V2.00429Z"
        fill="#4B5563"
      />
      <path
        d="M6.85628 18.0465V8.63008H3.72639V18.0465H6.85661H6.85628ZM5.29199 7.34465C6.38322 7.34465 7.06258 6.62157 7.06258 5.71794C7.04215 4.79371 6.38322 4.09082 5.31274 4.09082C4.24153 4.09082 3.5419 4.79371 3.5419 5.71786C3.5419 6.62149 4.22102 7.34457 5.27148 7.34457H5.29174L5.29199 7.34465ZM8.58872 18.0465H11.7184V12.7885C11.7184 12.5075 11.7388 12.2257 11.8215 12.0249C12.0476 11.4624 12.5626 10.8801 13.4274 10.8801C14.5597 10.8801 15.0129 11.7435 15.0129 13.0095V18.0465H18.1425V12.6474C18.1425 9.75522 16.5986 8.40932 14.5394 8.40932C12.8512 8.40932 12.1097 9.35291 11.6978 9.99559H11.7186V8.63041H8.58888C8.62973 9.51378 8.58864 18.0469 8.58864 18.0469L8.58872 18.0465Z"
        fill="white"
      />
    </svg>
  );
}
